import React from "react";

let Loading = require("../components/loading");
let ModerationUploads = require("../components/moderation-uploads");
let ModerationNavigation = require("../components/moderation-navigation");
let ModerationSaveForLater = require("../components/moderation-save-for-later");
let ModerationSuspended = require("../components/moderation-suspended-uploads");
let ModerationUnderReview = require("../components/moderation-under-review");
let ModerationPreview = require("../components/moderation-preview");

class ModerationContainer extends React.Component {
    render() {
        let creatorSearch, underReview, saveForLater, suspended, preview;

        if (!this.props.params.previewUploadId) {
            creatorSearch = this.renderCreatorSearch();
            underReview = this.renderUnderReview();
            saveForLater = this.renderSaveForLater();
            suspended = this.renderSuspended();
        } else {
            // preview
            preview = this.renderPreview();
        }

        return (
            <div>
                <ModerationNavigation slug={this.props.params.slug} />
                {creatorSearch}
                {preview}
                {underReview}
                {saveForLater}
                {suspended}
            </div>
        );
    }

    renderCreatorSearch() {
        if (this.props.params.slug === "creators") {
            return <ModerationUploads />;
        } else {
            return null;
        }
    }

    renderPreview() {
        if (this.props.params.previewUploadId) {
            return (
                <ModerationPreview
                    uploadId={this.props.params.previewUploadId}
                />
            );
        } else {
            return null;
        }
    }

    renderUnderReview() {
        if (this.props.params.slug === "under-review") {
            return <ModerationUnderReview />;
        } else {
            return null;
        }
    }

    renderSaveForLater() {
        if (this.props.params.slug === "save-for-later") {
            return <ModerationSaveForLater />;
        } else {
            return null;
        }
    }

    renderSuspended() {
        if (this.props.params.slug === "suspended") {
            return <ModerationSuspended />;
        } else {
            return null;
        }
    }
}

module.exports = ModerationContainer;
